<template>
<div id="error-404">

	<div class="align-c">
		<h1 class="h1">Error 404</h1>
		<p>We're sorry, that content could not be found.</p>		
	</div>
			

</div>
</template>

<script>

export default {
	
	components: { 		
		
	},

	data(){ return {
			

	}},

	computed: {

		

	},

	methods: {

		

	},

}
</script>



// WEBPACK FOOTER //
// src/components/Error404.vue